import moment from 'moment';

export default {
  computed: {
    computedHeaders() {
      return {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem('access_token')}`,
        },
      };
    },
  },
  data() {
    return {
      css: {
        pagination: {
          activeClass: 'active',
          disabledClass: 'disabled',
          icons: {
            first: '',
            last: '',
            next: '',
            prev: '',
          },
          linkClass: 'link',
          pageClass: 'page',
          wrapperClass: 'pagination',
        },
        table: {
          tableClass: 'table table-striped table-hover',
          ascendingIcon: 'glyphicon glyphicon-chevron-up',
          descendingIcon: 'glyphicon glyphicon-chevron-down',
        },
      },
      dataHasLoaded: false,
    };
  },
  methods: {
    formatDate(value) {
      return moment(value).format('DD/MM/YYYY');
    },
  },
};
